//
// Template store
//

import * as client from 'api/client';
import { institution as institutionSchema } from 'api/schema';
import { normalize } from 'normalizr';
import { LOGOUT } from './auth';

// ------------------------------------
// Constants
// ------------------------------------

export const NO_TEMPLATE = {
  id: 0,
  title: ''
};

// ------------------------------------
// Action definitions
// ------------------------------------

export const REQUEST_INSTITUTIONS = 'INSTITUTIONS/REQUEST';
export const RECEIVE_INSTITUTIONS = 'INSTITUTIONS/RECEIVE';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchInstitutions = () => dispatch => {
  dispatch({ type: REQUEST_INSTITUTIONS });

  return client.get('/api/public/institutions')
    .then(json => {
      const { entities } = normalize(json, [ institutionSchema ]);
      dispatch({
        type: RECEIVE_INSTITUTIONS,
        institutions: entities.institutions
      });
    })
    .catch(console.error);
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INSTITUTIONS:
      return {
        ...state,
        pending: true
      };

    case RECEIVE_INSTITUTIONS:
      return {
        ...state,
        items: action.institutions,
        pending: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getAllInstitutions = state => {
  return Object.values(state.institutions.items ? state.institutions.items : {});
};

export const getInstitution = (state, id) => {
  const { items } = state.institutions;
  return items.hasOwnProperty(id)
    ? { ...items[id] }
    : null;
};



// WEBPACK FOOTER //
// ./src/store/modules/institutions.js